// Dutch date utilities: dd-mm-yyyy, week starts Monday
export function fmtNL(dateInput) {
  if (!dateInput) return "";
  const d = typeof dateInput === "string" ? new Date(dateInput) : dateInput;
  if (isNaN(d.getTime())) return "";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}-${mm}-${d.getFullYear()}`;
}

export function isoDate(d) {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

export function mondayOf(date) {
  const d = new Date(date);
  // If weekend, jump to next Monday so demo screens don't open empty
  const day = d.getDay(); // 0=sun, 1=mon, ..., 6=sat
  let diff;
  if (day === 0) diff = 1;         // Sun → +1
  else if (day === 6) diff = 2;    // Sat → +2
  else diff = 1 - day;             // Mon..Fri → this week's Monday
  d.setDate(d.getDate() + diff);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function weekDays(monday) {
  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date(monday);
    d.setDate(monday.getDate() + i);
    return d;
  });
}

export function addDays(d, n) {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
}

export const DAY_NAMES = ["Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag", "Zondag"];
export const DAY_NAMES_SHORT = ["MA", "DI", "WO", "DO", "VR", "ZA", "ZO"];
export const MONTHS = ["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"];

export function niceDate(d) {
  const day = DAY_NAMES[(new Date(d).getDay() + 6) % 7];
  return `${day} ${fmtNL(d)}`;
}
